export default api => {
	return {
		init: `${api}/api/user-portal/boot`,
		contactUsBubble: `${api}/api/contact-us-bubble`,
	};
};
